import Vue from 'vue'
import { config } from '../config/config'

export default {
  filters: {
    dateFormat (value, vm) {
      let date = new Date(value)
      let options = config.dateFormatOptions
      date.setHours(Math.abs(date.getTimezoneOffset() / 60))
      return date.toLocaleDateString(Vue.config.lang, options)
    },
    currencyFormat (value, currency, vm) {
      if (!config.useCustomCurrencyFormat) {
        let formatter = new Intl.NumberFormat(Vue.config.lang, {
          style: 'currency',
          currency: currency
        })
        return formatter.format(value)
      }
      let formatter = new Intl.NumberFormat(Vue.config.lang, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
      let val = formatter.format(value)
      return vm.$t(`deck.currency-format-${currency}`, { integerPart: val })
    }
  },
  create () {
    Object.keys(this.filters).forEach(function (filter, k) {
      Vue.filter(filter, this.filters[filter])
    }.bind(this))
  }
}
